import { Button, ButtonProps } from '@mm/components/src/Button/Button';
import { Spinner, SpinnerProps } from '@mm/components/src/Spinner/Spinner';
import React, { FunctionComponent } from 'react';
import { useGuardedConnectOAuthToken } from './use-guarded-connect-o-auth-token';

interface Props {
  fetchOauthPopupUrl: (...params: any[]) => Promise<string | undefined>;
  oauthSuccessMessageType:
    | 'googleAccountConnected'
    | 'microsoftAccountConnected'
    | 'salesForceTokenReceived';
  onRefreshNeeded?: () => void;
  popupName?: string;
  popupWidth?: number;
  popupHeight?: number;
  buttonProps?: Pick<
    ButtonProps,
    'size' | 'color' | 'css' | 'disabled' | 'leftIcon'
  >;
  spinnerProps?: Pick<SpinnerProps, 'size' | 'width'>;
  featureFlag: string;
  landmineName: string;
  connectParams?: any[];
}

export const OAuthPopupActionButton: FunctionComponent<Props> = props => {
  const {
    featureFlag,
    landmineName,
    popupName,
    oauthSuccessMessageType,
    fetchOauthPopupUrl,
    children,
    buttonProps,
    spinnerProps,
    onRefreshNeeded,
    popupWidth,
    popupHeight,
    connectParams = [],
  } = props;
  const { connect, popupOpen } = useGuardedConnectOAuthToken(
    featureFlag,
    landmineName,
    popupName || 'oauth_popup',
    oauthSuccessMessageType,
    fetchOauthPopupUrl,
    onRefreshNeeded || (() => {}),
    { width: popupWidth, height: popupHeight },
  );

  return (
    <Button
      size="md"
      disabled={popupOpen}
      onClick={e => {
        e?.stopPropagation();
        connect(...connectParams);
      }}
      {...buttonProps}
    >
      {popupOpen && <Spinner standalone {...spinnerProps} />}
      {children || 'Connect to Google'}
    </Button>
  );
};
